import { render, staticRenderFns } from "./EditWorkingHours.vue?vue&type=template&id=8c4b68d4&scoped=true"
import script from "./EditWorkingHours.vue?vue&type=script&lang=js"
export * from "./EditWorkingHours.vue?vue&type=script&lang=js"
import style0 from "./EditWorkingHours.vue?vue&type=style&index=0&id=8c4b68d4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4b68d4",
  null
  
)

export default component.exports